import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import selectors from '../../../store/selectors';
import '../../../styles/index.scss';
import { Header } from '..';
import DonationWrapper from '../../Donate/DonationWrapper';
import DonateConfirmation from '../../Donate/DonateConfirmation';

import styles from './DonateLayout.module.scss';

const DonateLayout = () => {
  const isDonateConfirmation = useSelector(selectors.isDonateConfirmation);

  const isInBrowser = typeof window !== 'undefined';
  let content = null;
  if (isInBrowser) {
    content = isDonateConfirmation ? <DonateConfirmation /> : <DonationWrapper />;
  }

  return (
    <>
      <div className={classNames('app h-100 d-flex flex-column', styles.self)}>
        <Header description="Wsparcie - ofiara online" />

        {content}
      </div>
    </>
  );
};

DonateLayout.propTypes = {
  parishData: PropTypes.shape({
    accountId: PropTypes.string,
    short_name: PropTypes.string,
    full_name: PropTypes.string,
    avatar_url: PropTypes.string,
    background_image_url: PropTypes.string,
    address: PropTypes.shape({
      lines: PropTypes.arrayOf(
        PropTypes.shape({
          line: PropTypes.string,
        }),
      ),
      postal_code: PropTypes.string,
      city: PropTypes.string,
    }),
    bank_accounts: PropTypes.shape({
      accounts: PropTypes.arrayOf(
        PropTypes.shape({
          account_number: PropTypes.string,
        }),
      ),
    }),
    csrf: PropTypes.string,
    getRegulations: PropTypes.string,
    donationSuccessPageAdditionalText: PropTypes.string,
  }),
};

export default DonateLayout;
